import axios from "axios";
import { Markup } from "interweave";
import React, { useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import noImage from "../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";

const DetailsSouvenirStar = ({ souviner }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [appDecline, setAppDecline] = useState(true);

  const history = useHistory();

  const handleApprove = (id) => {
    axios.post(`/api/star/souviner/approve/${id}`).then((res) => {
      if (res.data.status === 200) {
        setAppDecline(false);
        swal("Welcome", res.data.message, "success");
      }
    });
  };
  const handleDecline = (id) => {
    axios.post(`/api/star/souviner/decline/${id}`).then((res) => {
      if (res.data.status === 200) {
        setAppDecline(false);
        swal("Welcome", res.data.message, "success");
        history.push("/superstar/souvenir/create");
      }
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 mb-3">
          <div className="card card-bg p-2">
            <img
              src={souviner?.banner ? imageCdnUrl + souviner?.banner : noImage}
              alt=""
              className="BannerAGN img-fluid"
            />
          </div>
        </div>
        {/* <div className="col-md-5 mb-3">
          <div className="card card-bg p-2">
            <ReactPlayer
              url={souviner?.video ? serverUrl + souviner?.video : null}
              width="100%"
              maxHeight="400px"
              playing={false}
              volume={1}
              controls={true}
              autoPlay
            />
          </div>
        </div> */}
      </div>

      <div className="mt-3 row">
        <div className="col-md-12">
          <div className="card suvenir-bg head-line">
            <div className="text-light d-flex justify-content-center p-2">
              <div className="faTrophy">
                <i className="fas fa-trophy"></i>
              </div>
              <h4 className="mx-3 text-white p-2">{souviner?.title}</h4>
            </div>
          </div>
          <div>
            <div className="card card-bg mt-2">
              <div className="card-body ">
                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={souviner?.instruction} />
                </p>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={souviner?.description} />
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-3">
              <div
                className="d-flex bg-dark mt-3 p-2 buTon-a "
                style={{ width: "100%" }}
              >
                <span>
                  <img src={PriceTag} alt="" className="PriceTage" />
                </span>
                <div className=" mx-2 ">
                  <span className="text-light buTon-ab ">Cost</span>
                  <br></br>
                  <span className="text-info fw-bold buTon-abc">
                    {souviner?.price} $
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-2 d-flex bg-dark mt-3 p-2 buTon-a ">
              <span>
                <img src={PriceTag} alt="" className="PriceTage" />
              </span>
              <div className=" mx-2 ">
                <span className="text-light buTon-ab ">Cost</span>
                <br></br>
                <span className="text-light buTon-abc">
                  {souviner?.price} $
                </span>
              </div>
            </div> */}
          <div className="mb-3">
            <div className="row mt-4">
              <div className="col-md-12 mx-auto row">
                {Number(souviner?.approval_status) === 0 && appDecline ? (
                  <div className="col-md-2">
                    <button
                      className="btn btnConfirm w-100 text-dark py-2 me-3 fw-bold mb-2"
                      onClick={() => handleApprove(souviner?.id)}
                    >
                      Approve
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {Number(souviner?.approval_status) === 0 && appDecline ? (
                  <div className="col-md-2 ">
                    <button
                      className="btn btnDecline w-100 text-dark py-2 me-3 fw-bold mb-2"
                      onClick={() => handleDecline(souviner?.id)}
                    >
                      Decline
                    </button>
                  </div>
                ) : (
                  ""
                )}

                {Number(souviner?.status) === 0 ? (
                  <div className="col-md-2">
                    <Link
                      to={`/superstar/souvenir/edit/${souviner?.id}`}
                      style={{ width: "170px" }}
                    >
                      <button className="btn btnEditTest w-100 text-dark py-2  fw-bold">
                        Edit <i className="fa fa-edit"></i>
                      </button>
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4"></div>
      </div>
    </>
  );
};

export default DetailsSouvenirStar;
